import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../../Themes/colors';
export var GlobalSearchWrapper = styled(Box)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 32,
    border: "1.5px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 4,
    backgroundColor: baseColors.greyPreset[50],
    transition: 'border-color 0.18s ease, background-color 0.18s ease',
    overflow: 'hidden',
    '&.focused': {
        borderColor: baseColors.successPreset[10],
        backgroundColor: baseColors.fullWhite,
    },
    '& .gs-module-btn': {
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        padding: '0 10px 0 12px',
        height: '100%',
        background: baseColors.greyPreset[45],
        border: 'none',
        borderRight: "1.5px solid ".concat(baseColors.greyPreset[40]),
        cursor: 'pointer',
        fontSize: 12,
        fontWeight: 500,
        color: baseColors.greyPreset[10],
        fontFamily: "'Nunito', sans-serif",
        whiteSpace: 'nowrap',
        flexShrink: 0,
        transition: 'background-color 0.12s',
        '&:hover': {
            backgroundColor: baseColors.greyPreset[40],
        },
        '& svg': {
            fontSize: 14,
            color: baseColors.greyPreset[30],
        },
    },
    '& .gs-search-icon': {
        display: 'flex',
        alignItems: 'center',
        padding: '0 6px 0 12px',
        flexShrink: 0,
        '& svg': {
            fontSize: 16,
            color: baseColors.greyPreset[10],
        },
    },
    '& .gs-input': {
        flex: 1,
        border: 'none',
        outline: 'none',
        background: 'transparent',
        fontSize: 12,
        color: baseColors.fullBlack,
        fontFamily: "'Nunito', sans-serif",
        paddingRight: 14,
        minWidth: 0,
        '&::placeholder': {
            color: baseColors.greyPreset[10],
            fontSize: 12,
        },
    },
});
export var SearchResultsDropdown = styled(Box)({
    backgroundColor: baseColors.fullWhite,
    borderRadius: 10,
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.10)',
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    overflow: 'hidden',
    maxHeight: 380,
    overflowY: 'auto',
    '& .result-group-header': {
        padding: '8px 16px 6px',
        fontSize: 12,
        fontWeight: 500,
        color: baseColors.greyPreset[30],
        backgroundColor: baseColors.greyPreset[50],
        borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
        borderTop: "1px solid ".concat(baseColors.greyPreset[40]),
        letterSpacing: 0.2,
        '&:first-of-type': {
            borderTop: 'none',
        },
    },
    '& .result-item': {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 16px',
        cursor: 'pointer',
        borderBottom: "1px solid ".concat(baseColors.greyPreset[50]),
        transition: 'background-color 0.12s',
        '&:hover': {
            backgroundColor: baseColors.successPreset[20],
        },
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    '& .result-name': {
        fontSize: 12,
        fontWeight: 500,
        color: baseColors.fullBlack,
        lineHeight: 1.4,
    },
    '& .result-id': {
        fontSize: 12,
        color: baseColors.successPreset[10],
        fontWeight: 500,
        marginTop: 2,
    },
    '& .result-empty': {
        padding: '18px 16px',
        fontSize: 12,
        color: baseColors.greyPreset[30],
        textAlign: 'center',
    },
    '& .result-error': {
        padding: '18px 16px',
        fontSize: 12,
        color: baseColors.errorPreset[20],
        textAlign: 'center',
    },
    '& .result-searching': {
        padding: '14px 16px',
        fontSize: 12,
        color: baseColors.greyPreset[30],
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
    },
    '& .result-load-more': {
        padding: '10px 16px 12px',
        fontSize: 12,
        color: baseColors.greyPreset[30],
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        borderTop: "1px solid ".concat(baseColors.greyPreset[50]),
        backgroundColor: baseColors.fullWhite,
    },
});
